module.exports = "./static/img_portrait.8d43fd3f.png";